
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Preweddingdestinationnearnagpur() {



  const cardData =
  {
    keyword: ' Pre Wedding Destination Near Nagpur',
    heading:  'Woodland Escape: Pre Wedding Destination Near Nagpur',
    headingDescription: 'Woodland Escape Resort, one of the best one day adventure resorts near Nagpur, offers an exciting blend of thrill and tranquility surrounded by lush greenery and serene forest landscapes just a short drive from the city. Perfect for families, friends, or corporate groups, the resort features a variety of adventure activities like ziplining, trekking, archery, and outdoor games, along with peaceful picnic spots, a swimming pool, and scenic nature trails for relaxation. Guests can enjoy delicious local and multi-cuisine meals while soaking in the refreshing atmosphere, making Woodland Escape Resort the ideal destination for a fun-filled and rejuvenating one-day getaway near Nagpur.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



 "services": [
    {
      "name": "One Day Adventure Resorts Near Nagpur",
      "description": "Woodland Escape Resort is one of the most exciting one-day adventure resorts near Nagpur, offering the perfect mix of fun, thrill, and relaxation. Guests can enjoy adventure activities like ziplining, rope courses, nature treks, and outdoor games surrounded by lush greenery. The resort also provides delicious meals, picnic areas, and a calm countryside setting — making it ideal for families, friends, and corporate groups seeking an adrenaline-filled day trip."
    },
    {
      "name": "Nagpur Adventure Day Trip",
      "description": "Plan your next adventure day trip from Nagpur to Woodland Escape Resort for a refreshing break packed with excitement. From obstacle courses and mud challenges to nature walks and team-building games, the resort offers a complete outdoor experience. Its scenic location and professional safety measures make it suitable for both beginners and adventure lovers alike."
    },
    {
      "name": "Nagpur Adventure Park",
      "description": "Woodland Escape Resort doubles as a natural adventure park near Nagpur, featuring fun and safe adventure zones for all age groups. Enjoy thrilling outdoor games, jungle trails, and group activities designed for recreation and exploration. The park’s open layout allows visitors to experience both the thrill of adventure and the tranquility of nature."
    },
    {
      "name": "Nagpur One Day Fun Resort",
      "description": "Looking for a one-day fun resort near Nagpur? Woodland Escape Resort is your destination for laughter, play, and relaxation. With outdoor adventure activities, scenic spots for photography, and delicious local meals, it’s the perfect getaway for families and friends. Spend the day enjoying nature, bonding, and having a blast in the open air."
    },
    {
      "name": "Affordable Adventure Resort Nagpur",
      "description": "Woodland Escape Resort is one of the most affordable adventure resorts near Nagpur. Guests can enjoy a full day of outdoor fun without overspending, thanks to budget-friendly packages that include meals and multiple activities. Whether you’re planning a group outing or a family picnic, it’s a value-for-money adventure experience close to the city."
    },
    {
      "name": "Nagpur Outdoor Adventure Spot",
      "description": "If you’re looking for an outdoor adventure spot near Nagpur, Woodland Escape Resort has you covered. From mountain biking and ziplining to nature trails and bullock cart rides, it offers diverse outdoor experiences for thrill seekers. The resort’s peaceful countryside location adds a refreshing touch to your adventurous outing."
    },
    {
      "name": "Nagpur Family Adventure Resort",
      "description": "Woodland Escape Resort is an excellent family adventure resort near Nagpur, providing safe and engaging activities for all age groups. Families can participate in team games, treasure hunts, and nature-based adventures together. With delicious food and comfortable amenities, it’s a wholesome experience that combines excitement with togetherness."
    },
    {
      "name": "Nagpur Weekend Adventure Trip",
      "description": "For those seeking a weekend adventure trip near Nagpur, Woodland Escape Resort offers the ideal escape. The resort provides day and overnight packages filled with outdoor games, adventure challenges, and nature walks. It’s the perfect destination for families, students, and corporate groups looking to unwind and recharge over the weekend."
    },
    {
      "name": "Nagpur Hill Adventure Resort",
      "description": "Experience an elevated thrill at Woodland Escape Resort, one of the top hill adventure resorts near Nagpur. The scenic hill surroundings make it perfect for trekking, ziplining, and panoramic nature walks. Guests can also enjoy breathtaking sunrise views and fresh mountain air, making it a memorable destination for adventure enthusiasts."
    },
    {
      "name": "Nagpur River Adventure Spot",
      "description": "Woodland Escape Resort is a serene yet thrilling river adventure spot near Nagpur. Guests can enjoy riverside picnics, kayaking, and outdoor games beside tranquil water views. The combination of adventure and relaxation makes it a unique place for nature lovers and thrill seekers to spend a fulfilling day outdoors."
    },
    {
      "name": "Nagpur Kids Adventure Resort",
      "description": "For families with children, Woodland Escape Resort serves as an exciting kids’ adventure resort near Nagpur. Safe play zones, fun obstacle courses, and interactive outdoor activities keep kids entertained while parents relax in the resort’s natural surroundings. It’s a great way to introduce little ones to adventure in a secure environment."
    },
    {
      "name": "Nagpur Adventure Activity Center",
      "description": "Woodland Escape Resort functions as a full-fledged adventure activity center near Nagpur. With options like wall climbing, ziplining, archery, and nature exploration, it’s a hub for group adventure programs. The resort also provides expert supervision to ensure safety and enjoyment throughout your experience."
    },
    {
      "name": "Nagpur Short Adventure Trip",
      "description": "For a short adventure trip from Nagpur, Woodland Escape Resort is an unbeatable choice. Just a short drive away, it offers a perfect mix of relaxation and outdoor fun. Guests can spend a few hours enjoying adventure activities, refreshing drinks, and the peaceful ambiance of nature before heading back home."
    },
    {
      "name": "Nagpur Resort Adventure Booking",
      "description": "Booking your adventure day at Woodland Escape Resort near Nagpur is simple and hassle-free. The resort offers customizable packages for individuals, families, and corporate teams. Whether you’re planning a one-day outing or a weekend adventure, advanced booking ensures your preferred time slots and activity access."
    },
    {
      "name": "Nagpur One Day Excursion",
      "description": "Woodland Escape Resort is the ultimate one-day excursion destination near Nagpur, offering a balance of adventure and leisure. Guests can engage in thrilling activities, explore nature, and enjoy freshly prepared meals in a serene environment. It’s the perfect location for school trips, corporate outings, and weekend getaways."
    }
  ],
  "tableData": [
    ["- One Day Adventure Resorts Near Nagpur", "- Nagpur Adventure Day Trip"],
    ["- Nagpur Adventure Park", "- Nagpur One Day Fun Resort"],
    ["- Affordable Adventure Resort Nagpur", "- Nagpur Outdoor Adventure Spot"],
    ["- Nagpur Family Adventure Resort", "- Nagpur Weekend Adventure Trip"],
    ["- Nagpur Hill Adventure Resort", "- Nagpur River Adventure Spot"],
    ["- Nagpur Kids Adventure Resort", "- Nagpur Adventure Activity Center"],
    ["- Nagpur Short Adventure Trip", "- Nagpur Resort Adventure Booking"],
    ["- Nagpur One Day Excursion", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Thrilling One Day Adventure Resort Near Nagpur",
    "WhyChoosedescription": "Woodland Escape Resort is one of the best one-day adventure resorts near Nagpur, offering an exciting blend of adrenaline, nature, and relaxation. Surrounded by dense forest and scenic landscapes, it’s the ideal destination for those who want to enjoy outdoor adventures while soaking in the beauty of nature — all within a short drive from Nagpur."
  },
  {
    "WhyChooseheading": "Adventure Amidst the Forest",
    "WhyChoosedescription": "Experience the thrill of adventure in a serene forest environment. Woodland Escape Resort offers a variety of exciting activities like zip-lining, rope courses, wall climbing, trekking, and cycling through scenic trails. Every activity is designed to give you the perfect mix of excitement and connection with nature."
  },
  {
    "WhyChooseheading": "Perfect for One Day Getaways",
    "WhyChoosedescription": "If you’re short on time but craving a break from routine, Woodland Escape Resort is the perfect one-day destination. Enjoy a full day packed with adventure, delicious food, and peaceful surroundings. The resort’s convenient location allows you to make the most of your day without worrying about long travel hours."
  },
  {
    "WhyChooseheading": "Fun for Friends, Families, and Groups",
    "WhyChoosedescription": "Whether you’re planning a trip with friends, a family outing, or a corporate team-building adventure, Woodland Escape Resort has something for everyone. With wide open spaces, forest trails, and safe adventure setups, it’s an ideal spot for creating fun and memorable moments together."
  },
  {
    "WhyChooseheading": "Delicious and Energizing Meals",
    "WhyChoosedescription": "Recharge between activities with wholesome, freshly prepared meals made from local ingredients. From hearty breakfasts to flavorful lunches and snacks, our kitchen ensures that every bite keeps your energy up while adding a touch of regional flavor to your adventure experience."
  },
  {
    "WhyChooseheading": "Relaxation Meets Adventure",
    "WhyChoosedescription": "After a day of thrilling activities, unwind by the pond, enjoy a peaceful forest walk, or simply relax under the trees. Woodland Escape Resort balances adventure and tranquility perfectly, allowing you to refresh both your mind and body before heading back to the city."
  },
  {
    "WhyChooseheading": "Easily Accessible from Nagpur",
    "WhyChoosedescription": "Located just a short drive from Nagpur, Woodland Escape Resort is easy to reach for a quick one-day adventure. The scenic journey through forest roads and countryside views sets the tone for a fun-filled day of exploration, making it one of the most convenient and exciting adventure resorts near Nagpur."
  }
]







  
  



  }

const faqData = [
  {
    question: "Why is Woodland Escape Resort one of the best one-day adventure resorts near Nagpur?",
    answer: "Woodland Escape Resort is the perfect destination for thrill-seekers and nature lovers alike. Surrounded by greenery and serene landscapes, the resort offers a variety of adventure activities and outdoor fun — all within a short drive from Nagpur."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur?",
    answer: "The resort is located around 45 km from Nagpur, approximately 1 to 1.5 hours by road. It’s easily accessible for a one-day adventure trip or a short weekend outing with family, friends, or colleagues."
  },
  {
    question: "What adventure activities are available at Woodland Escape Resort?",
    answer: "We offer a wide range of adventure experiences such as zip-lining, rope courses, rock climbing, trekking trails, archery, and nature walks. Guests can also enjoy boating, cycling, and fun outdoor games for all age groups."
  },
  {
    question: "Is the adventure package suitable for families and groups?",
    answer: "Yes! Our one-day adventure packages are designed for families, school groups, and corporate teams. Everyone can enjoy a mix of excitement and relaxation with safe, supervised activities for all age levels."
  },
  {
    question: "Does the resort provide meals in the adventure package?",
    answer: "Absolutely! Our one-day adventure package includes welcome drinks, a wholesome lunch, and evening tea with snacks. All meals are freshly prepared using locally sourced ingredients for an authentic countryside taste."
  },
  {
    question: "How can we book a one-day adventure trip at Woodland Escape Resort?",
    answer: "You can easily book your adventure day by contacting our team via phone, WhatsApp, or our official website. Advance booking is recommended to ensure slot availability, especially for weekends and group visits."
  }
];

const testimonials = [
  {
    name: "Mr. Sameer & Family, Nagpur",
    text: "Our one-day adventure at Woodland Escape Resort was fantastic! The zip-lining and trekking activities were thrilling, and the staff made sure everything was safe and well-organized. The kids loved it too — a great experience for the whole family!"
  },
  {
    name: "Miss. Rupal & Team, Nagpur",
    text: "We visited Woodland Escape Resort for a one-day adventure trip with our office team, and it was an unforgettable experience! The activities, food, and scenic atmosphere were perfect. One of the best adventure resorts near Nagpur!"
  }
];





      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pre Wedding Destination Near Nagpur",
  "image": "https://woodlandescape.com/assets/images/pre-wedding-destination-near-nagpur.jpg",
  "description": "Capture your love story at Woodlandescape Resort — the most romantic pre-wedding destination near Nagpur. Featuring scenic backdrops, gardens, lakesides, and luxury resort settings perfect for stunning pre-wedding photoshoots.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "876"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/pre-wedding-destination-near-nagpur"
  }
};




  return (
    <div>
<Helmet>
  <title>Pre Wedding Destination Near Nagpur | Romantic Shoot Location | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Make your memories timeless at Woodlandescape Resort — a stunning pre-wedding destination near Nagpur. Ideal for romantic couple shoots, garden backdrops, lakeside views, and cinematic photography sessions." 
  />
  <meta 
    name="keywords" 
    content="Pre Wedding Destination Near Nagpur, Nagpur Pre Wedding Shoot Location, Nagpur Romantic Shoot Spot, Nagpur Outdoor Pre Wedding Spot, Affordable Pre Wedding Spot Nagpur, Nagpur Resort Pre Wedding Shoot, Nagpur Scenic Pre Wedding Spot, Nagpur Garden Pre Wedding Location, Nagpur Riverside Shoot Spot, Nagpur Hill Pre Wedding Spot, Nagpur Couple Shoot Destination, Nagpur Pre Wedding Tour, Nagpur One Day Pre Wedding Shoot, Nagpur Pre Wedding Photography Location, Nagpur Booking for Pre Wedding Shoot" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/6.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Preweddingdestinationnearnagpur;